function placesInit() {
    document.dispatchEvent(new Event("google:init"));
}

window.placesInit = placesInit;

//Address AutoComplete
document.addEventListener("alpine:init", () => {
    window.Alpine.data("googlePlacesAddressAutocomplete", () => ({
        address_input_element: null,
        street_input_element: null,
        address_autocomplete: null,
        street_autocomplete: null,
        has_expanded_element_value: null,
        init() {
            this.address_input_element = this.$refs["address"];
            this.street_input_element = this.$refs["street"];

            const element_refs = ["street", "city", "state", "zipcode"];
            this.has_expanded_element_value = element_refs.some((name) => this.$refs[name].value);

            const init_autocomplete = () => {
                if (this.has_expanded_element_value) {
                    this.initStreetAutocomplete();
                } else {
                    this.initAddressAutocomplete();
                }
            };
            if (typeof window.google === "undefined") {
                document.addEventListener("google:init", init_autocomplete);
            } else {
                init_autocomplete();
            }
        },
        initAutocompleteFromElement(input_element) {
            const autocomplete_element = new window.google.maps.places.Autocomplete(input_element, {
                componentRestrictions: { country: "us" },
                fields: ["address_components"],
                types: ["address"],
            });
            autocomplete_element.addListener("place_changed", () => {
                this.fillInAddress(autocomplete_element.getPlace());
            });

            input_element.addEventListener("keydown", (event) => {
                if (event.which == "13") {
                    event.preventDefault();
                }
            });
            return autocomplete_element;
        },
        initAddressAutocomplete() {
            this.address_autocomplete = this.initAutocompleteFromElement(
                this.address_input_element,
            );
        },
        initStreetAutocomplete() {
            this.street_autocomplete = this.initAutocompleteFromElement(this.street_input_element);
        },
        fillInAddress(place) {
            const components = place.address_components;
            if (!components) {
                return;
            }
            const street_number =
                components.find((c) => c.types.includes("street_number"))?.short_name || "";
            const street_name = components.find((c) => c.types.includes("route"))?.long_name || "";
            const city = components.find((c) => c.types.includes("locality"))?.long_name || "";
            const state =
                components.find((c) => c.types.includes("administrative_area_level_1"))
                    ?.short_name || "";
            const zipcode =
                components.find((c) => c.types.includes("postal_code"))?.long_name || "";

            this.$refs["street"].value = `${street_number} ${street_name}`;
            this.$refs["city"].value = city;
            this.$refs["state"].value = state;
            this.$refs["zipcode"].value = zipcode;

            this.has_expanded_element_value = true;

            if (!this.street_autocomplete) {
                this.initStreetAutocomplete();
            }
        },
    }));
});

//Zip City State Autocomplete
document.addEventListener("alpine:init", () => {
    window.Alpine.data("googlePlacesZipCityStateAutocomplete", () => ({
        address_input_element: null,
        address_autocomplete: null,
        init() {
            this.address_input_element = this.$el;
            if (typeof window.google === "undefined") {
                document.addEventListener("google:init", () => {
                    this.initAutocomplete();
                });
            } else {
                this.initAutocomplete();
            }
        },
        initAutocomplete() {
            this.address_autocomplete = new window.google.maps.places.Autocomplete(
                this.address_input_element,
                {
                    types: ["(regions)"],
                    componentRestrictions: { country: "us" },
                    fields: ["address_components", "geometry", "name"],
                },
            );
            this.address_autocomplete.addListener("place_changed", () => {
                this.fillInZIPCityState(this.address_autocomplete.getPlace());
            });
        },
        fillInZIPCityState(place) {
            const components = place.address_components;
            const city = components.find((c) => c.types.includes("locality"))?.long_name || "";
            const state =
                components.find((c) => c.types.includes("administrative_area_level_1"))
                    ?.short_name || "";
            const zipcode =
                components.find((c) => c.types.includes("postal_code"))?.long_name || "";
            const parts = [];

            if (city) {
                parts.push(city);
            }

            if (state) {
                parts.push(state);
            }

            if (zipcode) {
                parts.push(zipcode);
            }

            this.address_input_element.value = parts.join(", ");
        },
    }));
    window.Alpine.data("googlePlacesSingleLineAddressAutocomplete", () => ({
        address_input_element: null,
        address_autocomplete: null,
        init() {
            this.address_input_element = this.$el;
            if (typeof window.google === "undefined") {
                document.addEventListener("google:init", () => {
                    this.initAutocomplete();
                });
            } else {
                this.initAutocomplete();
            }
        },
        initAutocomplete() {
            this.address_autocomplete = new window.google.maps.places.Autocomplete(
                this.address_input_element,
                {
                    types: ["address"],
                    componentRestrictions: { country: "us" },
                    fields: ["address_components", "geometry", "name"],
                },
            );
            this.address_autocomplete.addListener("place_changed", () => {
                this.fillInSingleLineAddress(this.address_autocomplete.getPlace());
            });
        },
        fillInSingleLineAddress(place) {
            const components = place.address_components;
            const street_number =
                components.find((c) => c.types.includes("street_number"))?.short_name || "";
            const street_name = components.find((c) => c.types.includes("route"))?.long_name || "";
            const city = components.find((c) => c.types.includes("locality"))?.long_name || "";
            const state =
                components.find((c) => c.types.includes("administrative_area_level_1"))
                    ?.short_name || "";
            const zipcode =
                components.find((c) => c.types.includes("postal_code"))?.long_name || "";
            const parts = [];

            if (street_number && street_name) {
                parts.push(`${street_number} ${street_name}`);
            }

            if (city) {
                parts.push(city);
            }

            if (state) {
                parts.push(state);
            }

            if (zipcode) {
                parts.push(zipcode);
            }

            this.address_input_element.value = parts.join(", ");
        },
    }));
});
